import React from 'react';
import {
  PageContainer,
  PageHeader,
  PageContent,
  Tabs,
  Panel,
} from '@cherre-frontend/ui';

import { DatasetValidationParametersPanel } from './panels/ValidationParameters/DatasetValidationParametersPanel';
import { CrossDatasetValidationParametersPanel } from './panels/ValidationParameters/CrossDatasetValidationParametersPanel';

export enum TabValues {
  DATASET_VALIDATION_PARAMETERS = 'Dataset Validation Parameters',
  CROSSDATASET_VALIDATION_PARAMETERS = 'Cross-Dataset Validation Parameters',
}

const SettingsAndConfiguration: React.FC = () => {
  const [tab, setTab] = React.useState<TabValues>(
    TabValues.DATASET_VALIDATION_PARAMETERS
  );

  return (
    <PageContainer id='SettingsAndConfigurationPage'>
      <PageHeader
        title='Settings & Configuration'
        subtitle='These settings and configurations will apply to your entire organization.'
      />
      <PageContent>
        <Tabs
          showBorder={false}
          tabs={[
            {
              label: TabValues.DATASET_VALIDATION_PARAMETERS,
              value: TabValues.DATASET_VALIDATION_PARAMETERS,
              disabled: false,
            },
            {
              label: TabValues.CROSSDATASET_VALIDATION_PARAMETERS,
              value: TabValues.CROSSDATASET_VALIDATION_PARAMETERS,
              disabled: false,
            },
          ]}
          value={tab}
          onChange={(_, newValue) => setTab(newValue)}
          tabPanels={[
            {
              value: TabValues.DATASET_VALIDATION_PARAMETERS,
              panel: (
                <Panel id='dataset-validation-parameters'>
                  <DatasetValidationParametersPanel />
                </Panel>
              ),
            },
            {
              value: TabValues.CROSSDATASET_VALIDATION_PARAMETERS,
              panel: (
                <Panel id='cross-dataset-validation-parameters'>
                  <CrossDatasetValidationParametersPanel />
                </Panel>
              ),
            },
          ]}
        />
      </PageContent>
    </PageContainer>
  );
};

export default SettingsAndConfiguration;
